const menu = [
	{ 
		name: '홈',
		img: 'sidebar-menu1.png',
		path: '/',
		pageKey: 'home',
		level: [1]
	},
	//{
	//	name: '시험분석팀 대시보드',
	//	img: 'sidebar-menu1.png',
	//	path: '/dashboard/analysis',
	//	page: 'dashboard/analysis',
	//	pageKey: 'dashboard',
	//	level: [2]
	//},
	{
		name: '관리자 대시보드',
		img: 'sidebar-menu1.png',
		path: '/dashboard/admin',
		// 노출 판정은 권한 매트릭스(pageKey → canAccessPage)가 정본이다.
		// 종전의 permission: ['ADMIN','SUB_ADMIN'] 하드코딩은 매트릭스 설정을
		// 무시하게 만들어 제거했다(2026-08-17). pageKey 없는 메뉴를 새로 만들 때만
		// Sidebar.canShowMenu 의 permission 배열 폴백이 동작한다.
		pageKey: 'admin'
	},
	{
		name: '고객사 관리',
		img: 'sidebar-menu2.png',
		path: '/client/list',
		page: 'client',
		pageKey: 'client'
	},
	{
		name: '시험 의뢰',
		img: 'sidebar-menu3.png',
		path: '/project/list',
		page: 'project',
		pageKey: 'project'
	},
	{
		name: '시험 분석',
		img: 'sidebar-menu4.png',
		path: '/analysis/list',
		pageKey: 'analysis'
	},
	{
		name: '정산',
		img: 'sidebar-menu5.png',
		path: '/settlement/list',
		page: 'settlement',
		pageKey: 'settlement'
	}
	// {
	// 	name: '멤버/조직',
	// 	img: 'sidebar-menu5.png',
	// 	path: '/member/list',
	// 	page: 'member'
	// }
]

/** sidebar 에 없는 page_key (권한 매트릭스 분류용) */
const PAGE_KEY_LABEL_EXTRA = {
	dashboard: '시험분석팀 대시보드',
	profile: '프로필'
}

/** page_key → sidebar 메뉴명 (없으면 PAGE_KEY_LABEL_EXTRA, 최종 fallback 은 pageKey) */
function getPageKeyLabel(pageKey) {
	if (!pageKey) return ''
	const fromMenu = menu.find(item => item.pageKey === pageKey)
	if (fromMenu) return fromMenu.name
	if (PAGE_KEY_LABEL_EXTRA[pageKey]) return PAGE_KEY_LABEL_EXTRA[pageKey]
	return pageKey
}

export { menu, getPageKeyLabel }